enum AnalyticsEventTypes {
  AlertError = 'alert_show_error',
  AlertInfo = 'alert_show_info',
  AlertSuccess = 'alert_show_success',
  AlertWarning = 'alert_show_warning',
  BuyStart = 'buy_start',
  BuyStartView = 'buy_start_view',
  BusinessError = 'business_error',
  CarQuoteStart = 'car_quote_start',
  CarQuoteComplete = 'car_quote_complete',
  CaravanQuoteComplete = 'caravan_quote_complete',
  CaravanQuoteStart = 'caravan_quote_start',
  CaravanPurchase = 'caravan_purchase',
  CarPurchase = 'car_purchase',
  EmailQuote = 'email_quote',
  ETClick = 'et_click',
  ETChange = 'et_change',
  ETModalShow = 'et_modal_show',
  ETModalClose = 'et_modal_close',
  EngagementTracking = 'engagement_tracking',
  FormStart = 'form_start',
  GeneralError = 'general_error',
  HomeQuoteStart = 'home_quote_start',
  HomeQuoteComplete = 'home_quote_complete',
  HomePurchase = 'home_purchase',
  IndicativeQuote = 'indicative_quote',
  MotorcycleQuoteStart = 'motorcycle_quote_start',
  MotorcycleQuoteComplete = 'motorcycle_quote_complete',
  MotorcyclePurchase = 'motorcycle_purchase',
  PaymentStartView = 'payment_start_view',
  PageView = 'page_view',
  Purchase = 'purchase',
  QuoteStart = 'quote_start',
  QuoteComplete = 'quote_complete',
  QuoteStartView = 'quote_start_view',
  RetrieveQuote = 'retrieve_quote',
  Search = 'search',
  SelectItem = 'select_item',
  Select = 'select',
  SMEQuoteStart = 'sme_quote_start',
  SMEIndicativeQuote = 'sme_indicative_quote',
  SMEPurchase = 'sme_purchase',
  SMEQuoteComplete = 'sme_quote_complete',
  TechnicalError = 'technical_error',
  TransactionStart = 'transaction_start',
  TransactionStartView = 'transaction_start_view',
  TransactionComplete = 'transaction_complete',
  ApiStart = 'api_start',
  ApiComplete = 'api_complete',
  ApiError = 'api_error',
  Navigation = 'navigation',
  ValidationError = 'validation_error',
  ViewItem = 'view_item',
  ViewItemList = 'view_item_list',
  ViewPromotion = 'view_promotion',
}

export { AnalyticsEventTypes };
